import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      <header className="navbar-main-sec index2-navbar-sec w-100 float-left">
        <div className="wrapper">
          <nav className="  navbar-light d-flex justify-content-between p-0">
            <a className="navbar-brand" href="#">
              <img
                src="../assets/images/logo/logo-light.svg"
                width={120}
                alt="logo"
              />
            </a>
            {/* <button
              className="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarToggle"
              aria-controls="navbarToggle"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
              <span className="navbar-toggler-icon" />
              <span className="navbar-toggler-icon" />
            </button> */}
            <Link to="/login" className="button-1 px-4 px-md-5 ">
              <div className="dots_border" />

              <span className="text_button">Login</span>
            </Link>
            {/* <div className="collapse navbar-collapse" id="navbarToggle">
              <ul className="navbar-nav mr-auto my-2 my-lg-0">
                <li className="nav-item dropdown active">
                  <a
                    className="nav-link dropdown-toggle"
                    href="javascript:void(0)"
                    id="navbarDropdown3"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Home
                  </a>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown3"
                  >
                    <a className="dropdown-item" href="index.html">
                      <i className="fas fa-angle-right" /> Home1
                    </a>
                    <a className="dropdown-item" href="index01.html">
                      <i className="fas fa-angle-right" /> Home2
                    </a>
                    <a className="dropdown-item" href="index02.html">
                      <i className="fas fa-angle-right" /> Home3
                    </a>
                  </div>
                </li>

                <li className="nav-item">
                  <a className="nav-link h6" href="#">
                    Contact
                  </a>
                </li>
              </ul>
            </div> */}
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Header;
